export default __webpack_public_path__ + "react-native.3eaa01c9.png";